import { loginUserWithRedirect } from 'auth/authUtils';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authenticatingUser } from 'redux/actions/auth';
import AddDashboardModal from 'components/AddDashboardModal/AddDashboardModal';
import PlantImage from 'assets/images/plant_image.jpg';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import SearchIcon from '@material-ui/icons/Search';
import './Home.css';
import { useHistory } from 'react-router';
import { Button } from '@material-ui/core';

const Home = () => {
    const authenticated = useSelector((state) => state.user.authenticated);
    const userAuthenticating = useSelector((state) => state.user.authenticatingUser);
    const showMobile = useSelector((state) => state.site.showMobile);
    const dispatch = useDispatch();
    const history = useHistory();
    const [show, setShow] = useState(false);

    const login = () => {
        dispatch(authenticatingUser());
        loginUserWithRedirect();
    };

    return (
        <>
            <div className='home-container'>
                <div className='home__banner-image__container'>
                    <img className='home__banner-image' src={PlantImage} alt='plant' />
                </div>
                <div className='home__content'>
                    <div className='home__content-container'>
                        <div className='home__content--description'>
                            <div className='home__content-subtitle'>Let's get started</div>
                            <div className='home__content-paragraph'>
                                QDash is a self-service tool that allows you to customize dashboards accessible from a single QR code. Each dashboard can
                                contain links to important documents, spreadsheets, forms, or other content.
                            </div>
                            <div className='home__button'>
                                {userAuthenticating && <div>Logging in...</div>}
                                {!userAuthenticating && authenticated && (
                                    <Button color='primary' size='large' variant='contained' onClick={() => setShow(true)}>
                                        Start
                                    </Button>
                                )}
                                {!userAuthenticating && !authenticated && (
                                    <Button onClick={login} color='primary' size='large' variant='outlined'>
                                        Login
                                    </Button>
                                )}
                            </div>

                            <div className='home__content-subtitle'>What can it do for me?</div>
                            <div>
                                <div className='home__content-paragraph'>
                                    QDash dashboard can improve productivity by providing access to essential resources, applications, and operational data.
                                </div>
                                <div className='home__content-paragraph'>
                                    Dashboards can be used to connect field workers to relevant documentation, information, and applicaitons to work faster and
                                    safer.
                                </div>
                            </div>

                            <div className='home__content-subtitle'>Why Qdash?</div>
                            <div className='home__content-paragraph'>
                                Easy QR (Quick Response) Code generation. Access to multiple sources (links) of data through a single QR code. Change where the
                                QR code leads to (destination URL) without ever physically changing the sticker in the field.
                            </div>
                            <div className='home__content-paragraph'>
                                Qdash is a tool for creation, application and implementation of QR codes. Dashboards can be used to connect field worked, on
                                demand, to relevant documentation and information for themto work faster and safer.
                            </div>
                        </div>
                        <div className='home__content--actions'>
                            <div
                                className={`${authenticated ? 'home-card' : 'home-card--not-allowed'}`}
                                onClick={() => authenticated && history.push('/mydashboards')}
                            >
                                {!showMobile && (
                                    <div className='home-card__icon-container'>
                                        <PersonOutlineIcon className='home-card__icon' />
                                    </div>
                                )}
                                <div className='home-card__message'>
                                    <div className='home-card__message-title'>My Dashboards</div>
                                    <div className='home-card__message-description'>View and browse dashboards that you own</div>
                                </div>
                            </div>
                            <div className={`${authenticated ? 'home-card' : 'home-card--not-allowed'}`} onClick={() => authenticated && setShow(true)}>
                                {!showMobile && (
                                    <div className='home-card__icon-container'>
                                        <AddCircleOutlineIcon className='home-card__icon' />
                                    </div>
                                )}
                                <div className='home-card__message'>
                                    <div className='home-card__message-title'>Add New Dashboard</div>
                                    <div className='home-card__message-description'>Create a new dashboard to add links too</div>
                                </div>
                            </div>
                            <div
                                className={`${authenticated ? 'home-card no-border-bottom' : 'home-card--not-allowed no-border-bottom'}`}
                                onClick={() => authenticated && history.push('/search')}
                            >
                                {!showMobile && (
                                    <div className='home-card__icon-container'>
                                        <SearchIcon className='home-card__icon' />
                                    </div>
                                )}
                                <div className='home-card__message'>
                                    <div className='home-card__message-title'>Search</div>
                                    <div className='home-card__message-description'>Search for dashboards at sites</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddDashboardModal show={show} setShow={setShow} />
        </>
    );
};

export default Home;
